import React from 'react';
import BottomSheet from '../components/BottomSheet/BottomSheet';
import Typography from '../components/Text/Typography';
import Toggle from '../components/Toggle/Toggle';
import './RecommendationsBottomSheet.css';

interface RecommendationsBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  showRecommendations: boolean;
  onToggleChange: (checked: boolean) => void;
}

const RecommendationsBottomSheet: React.FC<RecommendationsBottomSheetProps> = ({
  isOpen,
  onClose,
  showRecommendations,
  onToggleChange,
}) => {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Adjust routine page"
      height="auto"
      className="recommendations-bottom-sheet"
    >
      <div className="recommendations-content">
        <div className="recommendations-toggle-container">
          <Toggle
            checked={showRecommendations}
            onChange={onToggleChange}
            label="Show recommendations"
            id="show-recommendations-mobile"
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default RecommendationsBottomSheet;
